import util from '@bmp-vue/core/api/util'
import ui from '@bmp-vue/core/api/ui'
const controller = 'Voltz'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  TipoOperacaoCred: [
    { value: 1, text: 'Com Garantia' },
    { value: 2, text: 'Sem Garantia' },
    { value: 3, text: 'Financiamento/Refinanciamento' }
  ],
  Produtos: [],
  TipoContrato: [
    { grupo: '3', text: 'Capital de Giro com Garantia de Contrato', value: 'GGC' },
    { grupo: '1', text: 'Capital de Giro com Garantia de Imóveis', value: 'CGI' },
    { grupo: '2', text: 'Capital de Giro com Garantia de Veiculos, Máquinas ou Equipamentos', value: 'CGV' },
    { grupo: '3', text: 'Capital de Giro com Garantia de Recebiveis de Cartões', value: 'CGR' },
    { grupo: '3', text: 'Capital de Giro com Garantia de Duplicatas (DM)', value: 'CGD' },
    { grupo: '3', text: 'Capital de Giro com Garantia de Cotas de SPE', value: 'CGC' },
    { grupo: '4', text: 'Capital de Giro com Garantia', value: 'CCG' },
    { grupo: '4', text: 'Capital de Giro', value: 'CSG' },
    { grupo: '2', text: 'Financiamento de Veiculos', value: 'FV' },
    { grupo: '2', text: 'Financiamento de Máquinas e Equipamentos', value: 'FME' },
    { grupo: '1', text: 'Financiamento de Imóveis', value: 'FI' },
    { grupo: '4', text: 'Floor Plan', value: 'FP' },
    { grupo: '4', text: 'Conta Garantida', value: 'CGG' },
    { grupo: '3', text: 'Antecipação de Recebiveis de Cartões', value: 'AR' },
    { grupo: '3', text: 'Antecipação de Duplicatas', value: 'ADD' },
    { grupo: '1', text: 'Home Equity', value: 'CCI' },
    { grupo: '2', text: 'Refinanciamento de Veiculos', value: 'RV' },
    { grupo: '2', text: 'Refinanciamento de Máquinas e Equipamentos', value: 'RME' },
    { grupo: '4', text: 'Consignado Privado', value: 'CCR' },
    { grupo: '4', text: 'Hot Money', value: 'HOT' },
    { grupo: '4', text: 'Crédito Rotativo', value: 'CR' },
    { grupo: '4', text: 'Crédito Direto ao Consumidor', value: 'CDC' },
    { grupo: '4', text: 'Crédito Pessoal – Empréstimo Pessoal', value: 'CP' }
  ],
  GetTipoOperacaoByTipoPessoa (documentoFederal, param) {
    var tipoOp = param.flatMap(p => p.TipoOperacao)
    if (ui.Format.SomenteNumeros(documentoFederal).length === 11) { return ctrl.TipoOperacaoCred.filter(p => p.value !== 2 && tipoOp.includes(p.value)) }
    return ctrl.TipoOperacaoCred.filter(p => tipoOp.includes(p.value));
  },
  GrupoBem: [
    { value: 1, text: 'Bens Imóveis' },
    { value: 2, text: 'Bens Móveis' },
    { value: 3, text: 'Bens Financeiros' }
  ],
  GrupoBemEnum: {
    BemImovel: 1,
    BemMovel: 2,
    BemFinanceiro: 3,
  },
  CodigoTipoGarantia: [
    { chave: '3_99', grupo: 3, value: 99, text: 'AF Outros Bens Financeiros' }
  ],
  GetProdutos (documentoFederal, tipoOperacao, params) {
    var documento = ui.Format.SomenteNumeros(documentoFederal)
    var tipoDocumento = documento.length === 11 ? 'PF' : 'PJ'
    var produtos = []
    produtos = ctrl.GetProdutosByPessoaOperacao(params, tipoDocumento, tipoOperacao)
    return produtos
  },
  GetProdutosByPessoaOperacao (parametro, tipoPessoa, tipoOperacao) {
    if (tipoOperacao) {
      const i = parametro.findIndex(el => el.TipoPessoa === tipoPessoa && el.TipoOperacao === tipoOperacao)
      if (i !== -1) {
        return ctrl.TipoContrato.filter(p => { return parametro[i].Produtos.findIndex(j => j.Sigla === p.value) >= 0 })
      } else {
        ui.Mensagem('Alerta', 'Não existe Produto definido para este tipo de Pessoa/Operação')
        return []
      }
    }
  },
  ModeloCalculoEnum: {
    Price: 1,
    SAC: 2
  },
  Indexador: [
    { value: 1, text: 'CDI' },
    { value: 2, text: 'SELIC' },
    { value: 3, text: 'IPCA' },
    { value: 4, text: 'PTAX' },
    { value: 5, text: 'IGP-M' }
  ],
  TipoAssinanteEnum: {
    Emitente: 1,
    Avalista: 3,
    Conjuge: 4,
    Outros: 9
  },
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * th.$param.VlrMinEntrada).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  SaveProposta (th, callback) {
    if (th.$route.query.codigoProposta || th.model.Codigo) {
      saveProposta(callback, true)
    } else {
      const dto = {
        CodigoOperacao: th.model.CodigoOperacao,
        DocumentoCliente: th.model.Cliente.DocumentoFederal,
        DocumentoParceiroCorrespondente: th.$api.UI.Format.SomenteNumeros(
          th.$empresa.documentoFederal
        ),
        VlrSolicitado: th.model.TipoOperacaoCred === 3 ? (th.model.VlrProdutoBem - th.model.VlrEntrada) : th.model.VlrSolicitado,
        VlrEntrada: th.model.TipoOperacaoCred === 3 ? th.model.VlrEntrada : 0,
        Prazo: th.model.QtdeParcelasSolicitado,
        FormatoCalculo: 1,
        PercJurosNegociado: th.model.PercJurosMensal,
        VlrIOF: th.model.VlrIOF,
        PercIOF: th.model.PercIOF,
        QtdeParcelas: th.model.QtdeParcelasSolicitado,
        VlrParcela: th.model.VlrParcela,
        VlrTAC: th.model.VlrTAC,
        VlrBoleto: th.model.VlrBoleto,
        DtPrimeiroVencto: th.model.DtPrimeiroVencto,
        PropostaContaPagamentoDTO: {
          DocumentoFederalPagamento: th.model.ContaPagamento.DocumentoFederal,
          NomePagamento: th.model.ContaPagamento.Nome,
          TipoConta: th.model.ContaPagamento.TipoConta === 3 ? 2 : th.model.ContaPagamento.TipoConta,
          Agencia: th.model.ContaPagamento.Agencia.split('-')[0],
          AgenciaDig: th.model.ContaPagamento.Agencia.split('-')[1],
          Conta: th.model.ContaPagamento.Conta.split('-')[0],
          ContaDig: th.model.ContaPagamento.Conta.split('-')[1],
          CodigoBanco: th.model.ContaPagamento.CodigoBanco,
          NumeroBanco: th.model.ContaPagamento.NumeroBanco
        },
        CodigoVersaoCCB: th.model.CodigoVersaoCCB,
        TipoContrato: th.model.TipoContratoSigla
      }
      if (th.model.OutrosServicos) {
        dto.VlrSeguro = (th.model.VlrSeguro || 0)
        dto.VlrAvaliacao = (th.model.VlrAvaliacao || 0)
        dto.VlrOutrasDespesas = (th.value.VlrOutrasDespesas || 0)
        dto.VlrVistoria = (th.model.VlrVistoria || 0)
      }

      if (th.model.TipoOperacaoCred === 3) {
        dto.VlrProdutoBem = th.model.VlrProdutoBem
      }

      if (th.model.TipoDesembolso === th.$api.Enums.TipoDesembolso.Outros) {
        dto.DocumentoPromotor = th.model.Promotor.DocumentoFederal
      }
      const parametros = [
        { Nome: 'SituacaoPropostaEmDigitacao', Valor: true }
      ]
      th.$api.Multiplo.Post('IncluirPropostaManual', { dto, parametros }).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.$set(th.model, 'Codigo', response.Codigo)
          th.$api.Multiplo.Post('FindRecordProposta', { guidID: response.Codigo }).then(function (proposta) {
            if (th.$api.UI.PostLoadData(proposta)) {
              proposta.Cliente = Object.assign(th.model.Cliente, proposta.Cliente)
              th.$api.UTIL.Functions.SetAllButNull(th, th, 'model', proposta)
              saveProposta(callback)
            }
          })
        }
      })
    }

    function saveProposta (callback, atualizarContaPagamento) {
      const dtoSave = th.model
      dtoSave.UsarJurosProposta = true
      dtoSave.CodigoPromotor = null
      dtoSave.ByPassSituacaoOnSave = true
      dtoSave.PropostaValorSobreposto = {
        VlrTAC: th.model.VlrTAC,
        VlrAvaliacao: th.model.VlrAvaliacao
      }
      if (th.model.TipoDesembolso === th.$api.Enums.TipoDesembolso.Outros) {
        dtoSave.CodigoPromotor = th.model.Promotor.Codigo
      }
      th.$api.Multiplo.Post('SaveProposta', { dto: dtoSave }).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          ctrl.SavePropostaCampoAuxiliar(th)
          if (atualizarContaPagamento) { ctrl.SavePropostaContaPagamento(th, callback) } else { callback() }
        }
      })
    }
  },
  SavePropostaContaPagamento (th, callback) {
    const dto = {
      dto: {
        CodigoProposta: th.model.Codigo
      },
      dtoPagto: {
        DocumentoFederalPagamento: th.model.ContaPagamento.DocumentoFederal,
        NomePagamento: th.model.ContaPagamento.Nome,
        TipoConta: th.model.ContaPagamento.TipoConta === 3 ? 2 : th.model.ContaPagamento.TipoConta,
        Agencia: th.model.ContaPagamento.Agencia.split('-')[0],
        AgenciaDig: th.model.ContaPagamento.Agencia.split('-')[1],
        Conta: th.model.ContaPagamento.Conta.split('-')[0],
        ContaDig: th.model.ContaPagamento.Conta.split('-')[1],
        CodigoBanco: th.model.ContaPagamento.CodigoBanco,
        NumeroBanco: th.model.ContaPagamento.NumeroBanco
      }
    }
    th.$api.Multiplo.Post('PropostaAtualizarContaPagamentoEmDigitacao', dto).then(function (response) {
      if (th.$api.UI.PostLoadData(response, true)) {
        callback()
      }
    })
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.TipoOperacaoCred) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPOOPERACAO', ValorCampo: th.model.TipoOperacaoCred }) }
    if ([null, undefined].indexOf(th.model.TipoOperacaoNome) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPOOPERACAODESCRICAO', ValorCampo: th.model.TipoOperacaoNome }) }
    // if ([null, undefined].indexOf(th.model.TipoProduto) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPOPRODUTO', ValorCampo: th.model.TipoProduto }) }
    if ([null, undefined].indexOf(th.model.TipoIndexador) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPOINDEXADOR', ValorCampo: th.model.TipoIndexador }) }
    if ([null, undefined].indexOf(th.model.TipoCCB) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPOCCB', ValorCampo: th.model.TipoCCB }) }
    if ([null, undefined].indexOf(th.model.TipoDesembolso) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPODESEMBOLSO', ValorCampo: th.model.TipoDesembolso }) }

    if (campos.length > 0) { th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos }) }
  },
  ListPropostaCampoAuxiliar (th, codigoProposta) {
    const dto = { parameters: [{ name: 'CodigoProposta', value: codigoProposta }] }

    th.$api.Multiplo.Post('ListPropostaCampoAuxiliar', dto).then(response => {
      if (th.$api.UI.PostLoadData(response, true)) {
        if (response.Data && response.Data.length > 0) {
          response.Data.forEach(item => {
            if (item.NomeCampo === 'PROPOSTA_TIPOOPERACAO') { th.$set(th.model, 'TipoOperacaoCred', parseInt(item.ValorCampo)) }
            if (item.NomeCampo === 'PROPOSTA_TIPOOPERACAODESCRICAO') { th.$set(th.model, 'TipoOperacaoNome', item.ValorCampo) }
            // if (item.NomeCampo === 'PROPOSTA_TIPOPRODUTO') { th.$set(th.model, 'TipoProduto', parseInt(item.ValorCampo)) }
            if (item.NomeCampo === 'PROPOSTA_TIPOINDEXADOR') { th.$set(th.model, 'TipoIndexador', parseInt(item.ValorCampo)) }
            if (item.NomeCampo === 'PROPOSTA_TIPOCCB') { th.$set(th.model, 'TipoCCB', item.ValorCampo) }
            if (item.NomeCampo === 'PROPOSTA_TIPODESEMBOLSO') { th.$set(th.model, 'TipoDesembolso', item.ValorCampo) }
          })
        }
      }
    })

    if (th.model.VlrSeguro || th.model.VlrAvaliacao || th.model.VlrVistoria || th.model.VlrOutrasDespesas) {
      th.$set(th.model, 'OutrosServicos', true)
    }
  },
  labelsCSVExcel: [
    'Período',
    'Dados da Operação',
    'Coobrigação Assumida',
    'Coobrigação Recebida',
    '% Doctos Processados',
    '% Volume Processado',
    'Qtde Operações Discordância',
    'Vlr Operações Discordância',
    'Qtde Operações Sub Judice',
    'Vlr Operações Sub Judice',
    'Qtde Instituições',
    'Qtde Operações',
    'Risco Indireto Vendor',
    'Carteira a Vencer',
    'De 14 a 30 dias',
    'De 31 a 60 dias',
    'De 61 a 90 dias',
    'De 91 a 180 dias',
    'De 181 a 360 dias',
    'Mais de 360 dias',
    'Prazo Indeterminado',
    'Vencidos',
    'De 15 a 30 dias',
    'De 31 a 60 dias',
    'De 61 a 90 dias',
    'De 91 a 180 dias',
    'De 181 a 360 dias',
    'Mais de 360 dias',
    'Prejuízo',
    'Até 12 meses',
    'Acima 12 meses',
    'Limite de Crédito',
    'Até 360 dias',
    'Acima de 360 dias',
    'Carteira de Crédito',
    'Repasses',
    'Coobrigações',
    'Responsabilidade Total',
    'Créditos a Liberar',
    'Risco Indireto Vendor',
    'Risco Total',
    'Moeda Estrangeira - De 15 a 30 dias',
    'Moeda Estrangeira - De 31 a 60 dias',
    'Moeda Estrangeira - De 61 a 90 dias',
    'Moeda Estrangeira - De 91 a 180 dias',
    'Moeda Estrangeira - De 181 a 360 dias',
    'Moeda Estrangeira - Acima de 360 dias',
    'Modalidades'
  ],
  GetVlrMinTAC (th, documentoFederal, tipoOperacaoCred, vlrProdutoBem, vlrEntrada, vlrSolicitado) {
    let valor = 0
    if (!th.$param.EST_VALORES || !th.$param.EST_VALORES.TAC) { return }

    var tipoPessoa = ui.Format.SomenteNumeros(documentoFederal).length === 11 ? 1 : 2
    const tac = th.$param.EST_VALORES.TAC
    if ((tac.PF && tipoPessoa === 1) || (tac.PJ && tipoPessoa === 2)) {
      const solicitado = (tipoOperacaoCred === 3 ? vlrProdutoBem - vlrEntrada : vlrSolicitado)

      valor = th.$api.UI.Parse.Decimal((((tac.Perc || 0) / 100) * solicitado).toFixed(2))
      if (valor < tac.VlrMin) { valor = tac.VlrMin }
    }
    return valor
  },
  GetValorRegistro: async function (th, model) {
    if (!th.$param.EST_VALORES || !th.$param.EST_VALORES.Registro || th.$param.EST_VALORES.length === 0) { return }
    const registros = th.$param.EST_VALORES.Registro
    var vlrRegistro = 0
    const dto = { parameters: [{ name: 'CodigoProposta', value: model.Codigo }] }
    th.$set(model, 'VlrRegistro', 0)
    var response = await th.$api.Multiplo.Post('ListPropostaGarantiaBem', dto)
    if (th.$api.UI.PostLoadData(response)) {
      var tipoPessoa = ui.Format.SomenteNumeros(model.Cliente.DocumentoFederal).length === 11 ? 1 : 2
      for (var i = 0; i < response.Data.length; i++) {
        vlrRegistro += await this.GetValorRegistroGarantia(th, response.Data[i], tipoPessoa, registros)
      }
      th.$set(model, 'VlrRegistro', vlrRegistro)
    }
  },
  GetValorRegistroGarantia: async function (th, garantia, tipoPessoa, registros) {
    let vlrRegistro = 0

    const item = registros.find(p => p.Grupo === garantia.Grupo && p.Subgrupo === garantia.Subgrupo)
    if (item && ((item.PF && tipoPessoa === 1) || (item.PJ && tipoPessoa === 2))) {
      vlrRegistro += item.Valor || 0

      if (item.IndicadorGravame) {
        vlrRegistro += await getValorGravame()
      }
    }
    return ui.Parse.Decimal(vlrRegistro.toFixed(2))

    async function getValorGravame () {
      let valor = 0
      if (listaGravame && listaGravame.length > 0) {
        if (garantia && garantia.Grupo === 2 && garantia.Subgrupo === 1) {
          const dto = {
            guidID: garantia.Codigo
          }
          var response = garantia
          if (!response.PropostaGarantiaBemVeiculo) { response = await th.$api.Multiplo.Post('FindRecordPropostaGarantiaBem', dto) }
          if (th.$api.UI.PostLoadData(response) && response.PropostaGarantiaBemVeiculo) {
            garantia = response
            const gravame = listaGravame.find(p => p.uf === garantia.PropostaGarantiaBemVeiculo.UFLicenciamento)
            if (gravame) {
              switch (garantia.PropostaGarantiaBemVeiculo.TipoPlaca) {
                case 1:
                case 5:
                  valor += gravame.valorTipo1
                  break
                case 2:
                  valor += gravame.valorTipo2
                  break
                case 3:
                case 4:
                  valor += gravame.valorTipo3
                  break
              }
            }
          }
        }
      } else {
        var gravames = await th.$api.Kraken.GetAllGravames()
        if (th.$api.UI.PostLoadData(gravames)) {
          listaGravame = gravames
          return await getValorGravame(garantia)
        }
      }

      return valor
    }
  },
  listPapeis (th, tipoAssinante, model, proposta, documento, listDocFederalGarantia) {
    var list = th.$param.EST_PAPEIS.filter((p) => p.tipo === tipoAssinante)

    list = list.filter((p) => {
      if (proposta.Cliente.TipoPessoa === th.$aux.TipoPessoaEnum.PF && p.pf) {
        return true
      } else if (proposta.Cliente.TipoPessoa === th.$aux.TipoPessoaEnum.PJ && p.pj) {
        return true
      }
      return false
    })
    list = list.map((p) => { return { text: p.papel, value: p.papel } })
    if (model && model.length > 0) {
      model.forEach((p) => {
        var i = list.findIndex((j) => j.value === p.text)
        if (i >= 0) {
          p.value = p.text
          list[i] = p
        } else {
          list.push(p)
        }
      })
    }

    if (listDocFederalGarantia &&
      !listDocFederalGarantia.includes(documento) &&
      list.findIndex(({ text }) => text === 'TERCEIRO GARANTIDOR') > 0
    ) {
      const i = list.findIndex(({ text }) => text === 'TERCEIRO GARANTIDOR')
      list.splice(i, 1)
    }

    return list.filter(item => item)
  },
  ProprietarioGarantiaEnum: {
    Emitente: 1,
    TerceiroGarantidor: 2
  }
})
let listaGravame = []
export default ctrl
